import { getUID } from '@shared/helpers/uid';
// import { WorksheetsService } from '@autoinformer/services/WorksheetsService';
import { WorksheetItemService } from '@autoinformer/services/WorksheetItemService';
import { WorksheetActionModelSelector } from '@autoinformer/helpers/worksheets/action-types';
import isEqual from 'lodash-es/isEqual';
import flattenDeep from 'lodash-es/flattenDeep';
import transform from 'lodash-es/transform';
import pickBy from 'lodash-es/pickBy';
import pick from 'lodash-es/pick';
import get from 'lodash-es/get';

const getPositionComparisonFields = (item) => ({
  id: item.id,
  type: item.type,
  position: item.position
});

/**
 * id - ID текущей схемы
 * actions - Текущий массив элементов схемы
 * last_save_actions - Послдние сохранненые изменения элементов схемы. Нужен для поиска несохранных значений
 * current_menu_item_id - id элемента схемы, у которого открыто меню (кнопки: удалить, создать связь и т.п)
 *
 * connection_id_from, connection_id_to, current_cursor_position - нужны для создания связей
 * Когда человек начинает прокладывать связь, то в connection_id_from записывается ID элемента схемы,
 *  - Если навести на элемент, то connection_id_to запишется ID элемента на который навели
 *  - Если просто водить по полю, то координаты будут записаны в current_cursor_position
 **/
export const form = {
  namespaced: true,
  state: {
    id: null,
    actions: [],
    last_save_actions: [],
    current_menu_item_id: null,

    connection_id_from: null,
    connection_id_to: null,

    current_cursor_position: {
      x: 0,
      y: 0
    }
  },
  actions: {
    setActions: function ({ commit }, value) {
      commit('actions', value);
    },

    setLastSaveActions: function ({ commit }, value) {
      commit('last_save_actions', value);
    },

    setId: function ({ commit }, value) {
      commit('id', value);
    },

    setCampaignId: function ({ commit }, value) {
      commit('campaign_id', value);
    },

    setMenuId: function ({ commit }, value) {
      commit('current_menu_item_id', value);
    },

    clearMenuId: function ({ commit }) {
      commit('current_menu_item_id', null);
    },

    setCursorPosition: function ({ commit }, { layerX, layerY }) {
      commit('current_cursor_position', { x: layerX, y: layerY });
    },

    setConnectionIdFrom: function ({ commit }, value) {
      commit('connection_id_from', value);
    },

    setConnectionIdTo: function ({ commit }, value) {
      commit('connection_id_to', value);
    },

    addTemporaryItem({ dispatch, getters }, item) {
      const format_item = WorksheetActionModelSelector.getFrontendModel({
        ...item,
        id: getUID()
      });

      const items = getters['getActions'];
      dispatch('setActions', [...items, format_item]);
    },

    saveItem({ dispatch, getters }, { id, item }) {
      const replace_current_actions = dispatch('replaceActionInArray', {
        array: getters['getActions'],
        target_id: id,
        item: item
      });

      const replace_last_save_actions = dispatch('replaceActionInArray', {
        array: getters['getLastSaveActions'],
        target_id: id,
        item: item
      });

      Promise.all([replace_current_actions, replace_last_save_actions]).then((res) => {
        dispatch('setLastSaveActions', res[1]);
        dispatch('setActions', res[0]);
      });
    },

    removeItem({ dispatch, getters }, { id }) {
      const remove_current_actions = dispatch('removeItemFromArray', {
        array: getters['getActions'],
        target_id: id
      });

      const remove_last_save_actions = dispatch('removeItemFromArray', {
        array: getters['getLastSaveActions'],
        target_id: id
      });

      Promise.all([remove_current_actions, remove_last_save_actions]).then((res) => {
        dispatch('setLastSaveActions', res[1]);
        dispatch('setActions', res[0]);
      });
    },

    saveLastPosition({ dispatch, getters }, { id, position }) {
      dispatch('setActionPosition', {
        array: getters['getLastSaveActions'],
        target_id: id,
        position: position
      }).then((array) => dispatch('setLastSaveActions', array));
    },

    setActionPosition(_, { array, target_id, position }) {
      return array.map((findItem) => {
        if (findItem.id === target_id) {
          return { ...findItem, position };
        }

        return findItem;
      });
    },

    replaceActionInArray(_, { array, target_id, item }) {
      return array.map((findItem) => {
        if (findItem.id === target_id) {
          return item;
        }

        return findItem;
      });
    },

    removeItemFromArray(_, { array, target_id }) {
      return array.filter((findItem) => findItem.id !== target_id);
    },

    getAllowConnection({ getters }, { from_id, to_id }) {
      if (getters.isAllowAnyConnection(from_id, to_id)) {
        const from = getters.getActionById(from_id);
        const to = getters.getActionById(to_id);

        const free_connections = Object.keys(from.getFreeOptions());

        return free_connections.map((type) => ({
          from,
          to,
          type
        }));
      }

      return [];
    },

    saveConnect({ dispatch, getters }, { from_id, to_id, type }) {
      const worksheet_id = getters.getId;
      const from_element = getters.getActionById(from_id);
      const modify_element = from_element.createOption({ [type]: to_id });

      // return WorksheetsService.updateData(
      return WorksheetItemService.updateData(
        from_element.type,
        worksheet_id,
        from_element.id,
        modify_element.toBackend().getData()
      ).then((res) => {
        const save = dispatch('saveItem', { id: res.id, item: res });
        const reset = dispatch('resetConnect');
        return Promise.all([save, reset]);
      });
    },

    startConnect({ dispatch, getters }, id) {
      return dispatch('resetConnect').then(() => {
        const from = getters.getActionById(id);
        if (from.hasFreeOptions()) {
          return dispatch('setConnectionIdFrom', id);
        }
      });
    },

    resetConnect({ dispatch }) {
      return Promise.all([
        dispatch('setConnectionIdFrom', null),
        dispatch('setConnectionIdTo', null)
      ]);
    }
  },

  getters: {
    getActions: (state) => {
      const exist_ids = state.actions.map((action) => action.id);
      return state.actions.map((item) => {
        /**
         * С бека может прийти невалиданя свзяь (удалили в базу элемен)
         * Или на фронте при обновлении произошла ошибка.
         * Оставляем только связи к реальным элементам схемы.
         * + Это позволит нам не отслеживать все элементы, которые ссылаются на "удаляемый элемент"
         */
        const current_model = WorksheetActionModelSelector.getFrontendModel(item);
        const current_options = current_model.getOptions();
        const modify_options = pickBy(current_options, (value) => exist_ids.includes(value));
        const modify_item = current_model.setOptions(modify_options);

        return modify_item;
      });
    },

    getActionById: (state, getters) => (id) => {
      return getters.getActions.find((findItem) => findItem.id === id);
    },

    getLastSaveActions: (state) => state.last_save_actions,

    getId: (state) => {
      return state.id;
    },

    getCampaignId: (state) => {
      return state.campaign_id;
    },

    getCurrentCursorPosition: (state) => state.current_cursor_position,

    getConnectionIdFrom: (state) => state.connection_id_from,
    getConnectionIdTo: (state) => state.connection_id_to,
    getConnectionFrom: (state, getters) => getters.getActionById(getters.getConnectionIdFrom),
    getConnectionTo: (state, getters) => getters.getActionById(getters.getConnectionIdTo),

    isAllowAnyConnection: (state, getters) => (from_id, to_id) => {
      const from = getters.getActionById(from_id);
      const to = getters.getActionById(to_id);

      const base_check = [
        !isNaN(from.id),
        !isNaN(to.id),
        from.id !== to.id,
        from.hasFreeOptions(),
        to.isAllowedIncomingConnection()
      ].every((result) => result === true);

      if (base_check) {
        if (['menu'].includes(from.type)) {
          return true;
        } else {
          const exist_options = Object.values(from.getOptions());
          return !exist_options.includes(to.id);
        }
      }

      return false;
    },

    isMenuOpen: (state) => (id) => {
      return state.current_menu_item_id === id;
    },

    getPositionDifference: (state, getters) => {
      return getters.getActions
        .filter((current) => {
          const save_item = getters.getLastSaveActions.find((f) => f.id === current.id);

          if (save_item) {
            const current_position = getPositionComparisonFields(current);
            const last_position = getPositionComparisonFields(save_item);

            return !isEqual(current_position, last_position);
          }

          return false;
        })
        .map((item) => getPositionComparisonFields(item));
    },

    getRelationships: (state, getters) => {
      const actions_with_relationships = getters['getActions']
        .filter((action) => {
          /**
           * Получаем только те объекты, у которых есть связи
           */
          const relationships = get(action, 'data.options', {});
          return Object.keys(relationships).length > 0;
        })
        .map((action) => {
          const relationships = { ...get(action, 'data.options', {}) };

          /**
           * В объекте может содержаться
           * key_1: 15,
           * key_2: 20,
           * key_3 : 15
           *
           * Мы приводим к виду
           *
           * 15: ['key_1', 'key_3']
           */
          const relationships_transform = transform(
            relationships,
            function (result, value, key) {
              (result[value] || (result[value] = [])).push(key);
            },
            {}
          );

          /**
           * Опираться на ключи - такое себе. Потому формируем массив.
           */
          const relationships_format = Object.keys(relationships_transform).map((key) => ({
            connect_to_id: parseInt(key),
            keys: relationships_transform[key]
          }));

          return {
            from: pick(action, ['id', 'type']),
            relationships: relationships_format
          };
        });

      const deep_relationships = actions_with_relationships.map((action) => {
        const { relationships, from } = action;

        /**
         * Может содержать несколько связей, потому пробегаемся по каждому ключу
         */
        return relationships
          .map((r) => {
            const to = getters.getActionById(r.connect_to_id);

            return {
              from: from,
              keys: r.keys,
              to: pick(to, ['id', 'type'])
            };
          })
          .filter((item) => item.keys.length);
      });

      return flattenDeep(deep_relationships);
    }
  },

  mutations: {
    actions: function (state, actions) {
      state.actions = actions;
    },

    last_save_actions: function (state, actions) {
      state.last_save_actions = actions;
    },

    current_menu_item_id: function (state, id) {
      state.current_menu_item_id = id;
    },

    connection_id_from: function (state, id) {
      state.connection_id_from = id;
    },

    connection_id_to: function (state, id) {
      state.connection_id_to = id;
    },

    id: function (state, id) {
      state.id = id;
    },

    campaign_id: function (state, id) {
      state.campaign_id = id;
    },

    current_cursor_position: function (state, position) {
      state.current_cursor_position = position;
    }
  }
};
